import { render, staticRenderFns } from "./MessageIcon.vue?vue&type=template&id=4d744faa"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d744faa')) {
      api.createRecord('4d744faa', component.options)
    } else {
      api.reload('4d744faa', component.options)
    }
    module.hot.accept("./MessageIcon.vue?vue&type=template&id=4d744faa", function () {
      api.rerender('4d744faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/MessageIcon.vue"
export default component.exports